import React, { createContext, useContext, useEffect } from 'react';
import { Operations } from '#root/utils/offlineOperationHandlers';
import { offlineOperationsService } from '#root/services/offlineOperationsService';
import { useVictimOperations } from '#root/hooks/useVictimOperations';
import { useGeneralContactOperations } from '#root/hooks/useGeneralContactOperations';

const OfflineOperationsContext = createContext<Operations | null>(null);

export const OfflineOperationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const victimOperations = useVictimOperations();
    const generalContactOperations = useGeneralContactOperations();

    const operations: Operations = {
        victimOperations,
        generalContactOperations
    };

    useEffect(() => {
        offlineOperationsService.setOperations(operations);
    }, [victimOperations, generalContactOperations]);

    return (
        <OfflineOperationsContext.Provider value={operations}>
            {children}
        </OfflineOperationsContext.Provider>
    );
};

export const useOfflineOperations = () => {
    const context = useContext(OfflineOperationsContext);
    if (!context) {
        throw new Error('useOfflineOperations must be used within an OfflineOperationsProvider');
    }
    return context;
};
